import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { findComponentsDownward } from '../../utils/assist';

@Component
export default class EpicTabPanel extends Vue {
    public title: string = 'EpicTabPanel';
    public tabs: any[] = [];
    public tabChildren: any[] = [];

    @Prop({ default: null })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public mounted() {
        this.tabChildren = findComponentsDownward(this, 'EpicTabChild');
        this.tabChildren.map((v: any) => {
            this.tabs.push({
                name: v.name,
                active: v.active,
            });
        });
        this.tabChildren[0].active = true;
        this.tabs[0].active = true;
    }

    public switchChild(tab: any) {
        this.tabs.map((n: any) => {
            if (this.tabs.indexOf(tab) === this.tabs.indexOf(n)) {
                n.active = true;
                this.tabChildren[this.tabs.indexOf(tab)].active = true;
            } else {
                n.active = false;
                this.tabChildren[this.tabs.indexOf(n)].active = false;
            }
        });
    }
}
